import AbstractRepository from "@/repositories/AbstractRepository";
import {BudgetLever} from "@/repositories/socle/BudgetLeverRepository";

export interface Budget {
    uuid: string;
    label: string;
    totalRecommendedAmount: number;
    validationDeadline: string;
    budgetLevers: BudgetLever[];
    defaultBudget: boolean;
}

export default class BudgetRepository extends AbstractRepository {
    protected static resource: string = "ptf-socle-budget";

    protected static defaultFields: string[] = [
        "owner.uuid",
        "owner.fullName",
        "hierarchyOwner.uuid",
        "hierarchyOwner.fullName",
        "hierarchyOwner.corporateName",
        "hierarchyOwner.dependentStatus",
        "label",
        "campaign.uuid",
        "campaign.label",
        "campaign.startDate",
        "campaign.endDate",
        "budgetLevers.uuid",
        "budgetLevers.budget",
        "budgetLevers.budgetRecommended",
        "budgetLevers.comment",
        "budgetLevers.support",
        "budgetLevers.diffusion",
        "budgetLevers.format",
        "budgetLevers.lever.label",
        "uuid",
        "validatedAt",
        "createdAt",
    ];
}
